import { type PortalSettings, type FieldValues, type ColumnSettingsFieldValue } from '@gorilla/portal-shared/src/schemas';
import { SectionDescriptor, ColumnSettingsBoardSourceFieldDescriptor } from '@gorilla/portal-shared/src/types';
import { Box } from '@vibe/core';
import { ColumnSettings } from '../ColumnSettings';
import { useBoardSourceResolver } from '../../hooks/use-board-source-resolver';

type ColumnSettingsBoardSourceFieldProps = {
  value: ColumnSettingsFieldValue;
  fieldDescriptor: ColumnSettingsBoardSourceFieldDescriptor;
  sectionDescriptor: SectionDescriptor;
  portalSettings: PortalSettings;
  sectionFieldValues: FieldValues;
  onChange: (value: ColumnSettingsFieldValue) => void;
  clientBoardSubitemsBoardId: number | null;
  screenMode: 'small' | 'medium' | 'large';
  isOpen: boolean;
};

export function ColumnSettingsBoardSourceField({
  value,
  fieldDescriptor,
  portalSettings,
  onChange,
  sectionDescriptor,
  sectionFieldValues,
  clientBoardSubitemsBoardId,
  screenMode,
  isOpen,
}: ColumnSettingsBoardSourceFieldProps) {
  const { board, isLoading, boardId } = useBoardSourceResolver({
    portalSettings,
    sectionDescriptor,
    clientBoardSubitemsBoardId,
    sectionFieldValues,
  });

  if (!boardId || isLoading || !board) {
    return null;
  }

  const mode =
    sectionDescriptor.type === 'item-grid'
      ? 'grid'
      : sectionDescriptor.type === 'item-table'
        ? 'table'
        : sectionDescriptor.type === 'client-item-summary'
          ? 'clientitem'
          : undefined;
  const detailViewEnabled = !!(sectionFieldValues as any)?.['detail-view']?.enabled;

  return (
    <>
      <Box
        border={true}
        borderColor="layoutBorderColor"
        className={`section__field section__field--${fieldDescriptor.type} section__field--nomargin column--settings--wrapper`}
      >
        {isOpen ? (
          <ColumnSettings
            board={board}
            columnSettings={value || {}}
            showEditItemValueButton={!!fieldDescriptor.supportsEditingValues}
            onChange={(newColumnSettings) => {
              onChange(newColumnSettings);
            }}
            screenMode={screenMode}
            mode={mode}
            showScopeDropdown={detailViewEnabled}
            showAggregateButton={sectionDescriptor.type === 'item-table'}
          />
        ) : null}
      </Box>
    </>
  );
}
